module.exports = __webpack_public_path__ + "static/media/education-object-2-1-1.68a90d71.png";